import {InnerItem} from "./InnerItem";
import provideAlternativeImage from "../images/provide_alternative.png";
import empowerActorsImage from "../images/empower_actors.png";
import beDrivingForceImage from "../images/be_driving_force.png";
import empowerProducersImage from "../images/empower_producers.png";


let aboutUsItems: InnerItem[] = [
    {
        title: "Provide alternative",
        content: "Provide a time and cost-efficient alternative to traditional casting methods for film, TV, & commercials",
        image: provideAlternativeImage,
    },
    {
        title: "Empower actors",
        content: "Empower actors of all levels to discover more opportunities in a safe, low-cost/free manner \n",
        image: empowerActorsImage,
    },
    {
        title: "Be driving force",
        content: "Be a driving force in the film industry’s shift to new geographies and undiscovered human capital\n ",
        image: beDrivingForceImage,
    },
    {
        title: "Empower independent producers",
        content: "Empower independent producers with more casting options in a low-cost/free manner",
        image: empowerProducersImage,
    },
]
export default  aboutUsItems